import React from 'react';
export function ProductIntro() {
  return <section className="py-16 px-4 relative overflow-hidden bg-light-pink" data-id="element-344">
      <div className="absolute inset-0 bg-pink-200 opacity-20 transform -skew-y-3" data-id="element-345"></div>

      <div className="max-w-4xl mx-auto relative z-10 text-center" data-id="element-346">
        <div className="inline-block bg-teal-400 text-white font-bold px-6 py-2 rounded-full mb-6 text-sm md:text-base uppercase tracking-widest shadow-sm" data-id="element-347">
          La solución definitiva
        </div>

        <h2 className="text-4xl md:text-6xl font-bold text-magenta mb-8 drop-shadow-sm" data-id="element-348">
          🪄 PRESENTAMOS: KIT FIESTA MÁGICA
        </h2>

        <p className="text-2xl font-bold text-teal-600 mb-8" data-id="element-349">
          El kit imprimible más completo del mercado.
        </p>

        <div className="bg-white rounded-3xl p-8 shadow-xl border-4 border-pink-200 mb-10" data-id="element-350">
          <p className="text-xl text-gray-700 leading-relaxed" data-id="element-351">
            <strong className="text-magenta text-2xl" data-id="element-352">
              +10,000 diseños profesionales
            </strong>
            , personalizables y listos para imprimir — con todos los personajes
            que tus hijos aman, herramientas para editar desde el teléfono y
            tutoriales paso a paso.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-4 md:gap-8 text-lg font-bold text-pink-700" data-id="element-353">
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-354">
            <span data-id="element-355">🛍️</span> Una compra
          </div>
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-356">
            <span data-id="element-357">⚡</span> Acceso inmediato
          </div>
          <div className="flex items-center gap-2 bg-pink-100 px-6 py-3 rounded-2xl border border-pink-200" data-id="element-358">
            <span data-id="element-359">🎉</span> Fiestas ilimitadas
          </div>
        </div>
      </div>
    </section>;
}